export default "__VITE_ASSET__DmUzgvb9__"